/**
 * Wave 356 · Dry-run schemas — simulation of proposed actions.
 * Shape documented here; ships in 356.
 */

import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';

export const DryRunDTOSchema = z.object({
  id: idSchema,
  proposalId: idSchema,
  simulatedOutcome: z.unknown(),
  risks: z.array(z.string()),
  createdAt: isoDateTimeSchema,
});
export type DryRunDTO = z.infer<typeof DryRunDTOSchema>;
